import { Checkbox, Dialog, DialogTitle, FormControlLabel, TextField, ToggleButton, ToggleButtonProps } from '@mui/material';
import YouTubeIcon from '@mui/icons-material/YouTube';
import { useTranslate } from 'ra-core';
import { useTiptapEditor } from 'ra-input-rich-text';
import { Button } from 'ra-ui-materialui';
import React from 'react';

interface VideoDialiogProps {
  open: boolean;
  onOk: (url: string, useAlternativeUrl: boolean) => void;
  onClose: () => void;
}

const VideoModal = (props: VideoDialiogProps) => {
  const translate = useTranslate();
  const { onOk, onClose, open } = props;
  const [url, setUrl] = React.useState('');
  const [useAlternativeUrl, setUseAlternativeUrl] = React.useState(false);

  return (
    <Dialog onClose={onClose} open={open}>
      <DialogTitle>{translate('lto.rte.video.title')}</DialogTitle>
      <div style={{ display: 'flex', flexDirection: 'column', marginLeft: 24, marginRight: 24 }}>
        <TextField
          type="text"

          label={translate('lto.rte.video.placeholder')}
          defaultValue={""}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setUrl(event.target.value);
          }}
        />
        <FormControlLabel
          checked={useAlternativeUrl}
          onChange={(e, checked) => setUseAlternativeUrl(checked)}
          control={<Checkbox />}
          label={translate('lto.rte.video.altenativeUrl')} />
        <Button
          variant='contained'
          style={{ marginTop: 15, marginBottom: 7 }}
          onClick={() => {
            onOk(url, useAlternativeUrl);
            onClose();
          }}
          label={translate('lto.rte.video.save')}
        />
        <Button
          variant='outlined'
          style={{ marginBottom: 15 }}
          onClick={() => {
            onClose();
          }}
          label={translate('lto.rte.video.cancel')}
        />
      </div>

    </Dialog>
  )
}

export const VideoButton = (props: Omit<ToggleButtonProps, 'value'>) => {
  const editor = useTiptapEditor();
  const translate = useTranslate();

  const [open, setOpen] = React.useState(false);

  const label = translate('ra.tiptap.clear_format', {
    _: 'Add video',
  });

  const addVideo = (url: string, useAlternativeUrl: boolean) => {
    if (url) {
      editor.commands.setVideo({
        src: url,
        width: 640,
        height: 480,
        useAlternativeUrl: useAlternativeUrl
      })
    }
  }

  return (
    <>
      <ToggleButton
        aria-label={label}
        title={label}
        {...props}
        disabled={!editor?.isEditable}
        value="clear"
        onClick={() => setOpen(true)}
      >
        <YouTubeIcon fontSize="inherit" />
      </ToggleButton>
      <VideoModal open={open} onOk={addVideo} onClose={() => setOpen(false)} />
    </>
  );
};
